export default __webpack_public_path__ + "static/media/image-2.df79bfe5.jpeg";